import { makeAxiosRequestV1Api } from 'utils/api';

export const getTreatmentProducts = () => {
  return makeAxiosRequestV1Api('/treatment_products').then(response => response.resources);
};
